import { createContext, useContext } from 'react';

export type MessagingServiceContext = {
  baseUrl?: string;
};

const context = createContext<MessagingServiceContext>({});

export const useMessagingService = () => useContext(context);

export const MessagingServiceProvider = context.Provider;
